/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Code, Text } from '@mantine/core';
import { spotlight } from '@mantine/spotlight';
import { IconSearch } from '@tabler/icons-react';
import { useCallback } from 'react';

/**
 * TopSearchBar – simplified wrapper that triggers Mantine Spotlight.
 * Heavy search logic now resides in GlobalSpotlight.tsx.
 */
const TopSearchBar = () => {
  const osKey = useCallback(() => {
    const isMac = navigator.platform.toUpperCase().includes('MAC');
    return isMac ? '⌘ + K' : 'Ctrl + K';
  }, []);

  return (
    <div onClick={() => spotlight.open()} className="flex border bg-white border-gray-200 rounded-md px-2 py-0.5 items-center justify-between mt-6 w-full cursor-pointer select-none">
      <div className="flex items-center gap-2">
        <IconSearch size={12} stroke={1.5} className="text-gray-700" aria-hidden="true" />
        <Text size="xs" c="gray.7">Search</Text>
      </div>
      <Code>
     {osKey()}
      </Code>
    </div>
  );
};

export default TopSearchBar;
